var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotEqual(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M432 336C432 349.25 421.25 360 408 360H184.828L124.094 453.125C119.5 460.156 111.812 464 103.969 464C99.469 464 94.937 462.75 90.875 460.094C79.781 452.875 76.656 438 83.906 426.875L127.52 360H40C26.75 360 16 349.25 16 336S26.75 312 40 312H158.824L231.869 200H40C26.75 200 16 189.25 16 176S26.75 152 40 152H263.172L323.906 58.875C331.125 47.813 345.999 44.625 357.125 51.906C368.219 59.125 371.344 74 364.094 85.125L320.48 152H408C421.25 152 432 162.75 432 176S421.25 200 408 200H289.176L216.131 312H408C421.25 312 432 322.75 432 336Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotEqual);
export default __webpack_public_path__ + "static/media/not-equal.fe58a0ab255c152aa0b7557f4279fafd.svg";
export { ForwardRef as ReactComponent };